import { render, staticRenderFns } from "./OnboardingDownPayment.vue?vue&type=template&id=8c04ff28&scoped=true"
import script from "./OnboardingDownPayment.vue?vue&type=script&lang=js"
export * from "./OnboardingDownPayment.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDownPayment.vue?vue&type=style&index=0&id=8c04ff28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c04ff28",
  null
  
)

export default component.exports